<template>
  <div id="customPopUp" refs="customPopUp">
    <!-- :modal-class="'custom-popup'" -->
    <el-dialog
      :model-value="isVisible"
      :visible="isVisible"
      :modal="true"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      @close="handleCloseModal"
      @update:model-value="newValue => isVisible = newValue"
      width="30%">

      <template #header>
        <div class="dialog-title">
          <slot name="title"></slot>
        </div>
      </template>

      <perfect-scrollbar class="dialog-body cstm-ps-scrollbar-vertical">
        <slot name="body"></slot>
      </perfect-scrollbar>

      <template #footer>
        <div class="dialog-footer">
          <slot name="footer"></slot>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script src="./custom-popup.js"></script>
<style lang="scss" src="./custom-popup.scss"></style>
